const A_HANDLE = "[a-z][a-z0-9]*(?:-[a-z0-9]+)*";

const A_MENTION = new RegExp(`(?<![A-Za-z0-9_@./+-])@(${A_HANDLE})(?![A-Za-z0-9_-])`, "gi");

const A_FENCE = /(^|\n)[ \t]*(```|~~~)[^\n]*\n[\s\S]*?(?:\n[ \t]*\2[^\n]*|$)/g;
const A_CODE_SPAN = /`[^`\n]*`/g;
const A_QUOTED_LINE = /^[ \t]*>[^\n]*/gm;

const A_QUOTATION = /"[^"\n]*"|\u201c[^\u201d\n]*\u201d/g;

export function whatIsSaid(text: string): string {
  return text
    .replace(A_FENCE, (block) => " ".repeat(block.length))
    .replace(A_CODE_SPAN, (span) => " ".repeat(span.length))
    .replace(A_QUOTED_LINE, (line) => " ".repeat(line.length))
    .replace(A_QUOTATION, (quoted) => " ".repeat(quoted.length));
}

export function mentionsIn(text: string): string[] {
  const said = whatIsSaid(text);
  const found = new Set<string>();
  for (const match of said.matchAll(A_MENTION)) {
    const handle = match[1];
    if (handle) found.add(handle.toLowerCase());
  }
  return [...found];
}

export function addresses(text: string, handle: string): boolean {
  return mentionsIn(text).includes(handle.trim().toLowerCase());
}
